
import { configureStore } from '@reduxjs/toolkit';

import authSlice from './slices/AuthSlice';
import loadingSlice from './slices/LoadingSlice';
import bandejaSlice from './slices/BandejaReducer';
import snackbarSlice from './slices/SnackbarSlice';

const store = configureStore({
    reducer: {
        auth:       authSlice,
        loading:    loadingSlice,
        bandeja:    bandejaSlice,
        snackbar:   snackbarSlice,
    },
});

export type RootState = ReturnType<typeof store.getState>

export default store